import React from 'react';
import { useT } from '../../i18n';
import { chainId, dexSwapUrl, erc20Address } from '../../.config';
import { num, formatUsd } from './cdpHelpers';

// a market within this distance of the oracle counts as on peg
const PEG_BAND_BPS = 100;

/** The synth's USDT pair on the DEX: market price against the oracle, depth and where to trade it */
const SynthMarket = ({ synth }) => {
  const t = useT();
  const { dex } = synth;
  if (!dex) {
    return <p className="text-xs text-white/45">{t('cynths.noMarket')}</p>;
  }

  const oracle = synth.price ? num(synth.price) : null;
  const market = num(dex.price);
  const diffBps = oracle ? Math.round(((market - oracle) / oracle) * 10000) : null;
  const tone =
    diffBps === null || Math.abs(diffBps) <= PEG_BAND_BPS ? 'text-emerald-300' : diffBps > 0 ? 'text-amber-300' : 'text-rose-300';
  const swapUrl = dexSwapUrl.replace('{in}', erc20Address).replace('{out}', synth.token);

  return (
    <div className="lb-tile-soft flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="grid flex-1 grid-cols-3 gap-4">
        <div>
          <p className="lb-label">{t('cynths.marketPrice')}</p>
          <p className="notranslate font-bold text-white">{formatUsd(market)}</p>
        </div>
        <div>
          <p className="lb-label">{t('cynths.vsOracle')}</p>
          <p className={`notranslate font-bold ${tone}`}>
            {diffBps === null ? 'N/A' : `${diffBps > 0 ? '+' : ''}${(diffBps / 100).toFixed(2)}%`}
          </p>
        </div>
        <div>
          <p className="lb-label">{t('cynths.marketDepth')}</p>
          <p className="notranslate font-bold text-white">{formatUsd(num(dex.usdtReserve, 6) * 2)}</p>
        </div>
      </div>
      {chainId !== 31337 && (
        <a href={swapUrl} target="_blank" rel="noopener noreferrer" className="lb-btn lb-btn-outline lb-btn-sm text-center">
          {t('cynths.tradeOnDex')}
        </a>
      )}
    </div>
  );
};

export default SynthMarket;
